// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/spinner.scss
// module id = 244
// module chunks = 6